import { render } from "./RecordsPage.vue?vue&type=template&id=4f8809a0&scoped=true"
import script from "./RecordsPage.vue?vue&type=script&lang=js"
export * from "./RecordsPage.vue?vue&type=script&lang=js"

import "./RecordsPage.vue?vue&type=style&index=0&id=4f8809a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8809a0"]])

export default __exports__